import React from "react";
import { IconT } from "types/utils";

export default function ProposalStatusRejectedIcon({ height = "32", width = "32" }: IconT) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#F87C09" />
      <path
        d="M17.8332 7.08008V10.8664C17.8332 11.3798 17.8332 11.6365 17.9331 11.8326C18.021 12.005 18.1612 12.1453 18.3337 12.2332C18.5298 12.3331 18.7865 12.3331 19.2998 12.3331H23.0862M13.7082 15.9997L18.2915 20.583M18.2915 15.9997L13.7082 20.583M17.8332 6.83301H13.0665C11.5264 6.83301 10.7563 6.83301 10.168 7.13274C9.65058 7.39639 9.22989 7.81709 8.96624 8.33453C8.6665 8.92279 8.6665 9.69286 8.6665 11.233V20.7663C8.6665 22.3065 8.6665 23.0766 8.96624 23.6648C9.22989 24.1823 9.65058 24.603 10.168 24.8666C10.7563 25.1663 11.5264 25.1663 13.0665 25.1663H18.9332C20.4733 25.1663 21.2434 25.1663 21.8316 24.8666C22.3491 24.603 22.7698 24.1823 23.0334 23.6648C23.3332 23.0766 23.3332 22.3065 23.3332 20.7663V12.333L17.8332 6.83301Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
